import React, { FC } from 'react';
import styles from './search_filters_radio_content.module.scss';

export const SearchFiltersRadioContent: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
